// src/features/dashboard/Dashboard.tsx
// Page chrome (navbar, sidebar, scroll container) comes from AppLayout — the
// navbar is in normal flow there, so no page-level pt-16 offset is needed.
// This page only supplies the content, using min-h-0 so its columns stretch.
import React, { useEffect, useState } from "react";
import { removeAuthToken, getAuthToken } from "../../utils/api";
import { useNavigate, useLocation } from "react-router-dom";
import AppLayout from "../../shared/components/AppLayout";
import ThreadsSidebar from "../../shared/components/ThreadsSidebar";
import type { User } from "../../types/user";
import ChatBox from "../ChatBox/ChatBox";
import AppointmentsPage from "../appointments/AppointmentsPage";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<User | null>(null);
  const [selectedThreadId, setSelectedThreadId] = useState<string | null>(null);

  useEffect(() => {
    if (!getAuthToken()) {
      navigate("/login");
    } else {
      const userData = localStorage.getItem("user");
      if (userData) setUser(JSON.parse(userData));
    }
  }, [navigate]);


  /**
   * Handle thread selection
   */
  const handleThreadSelect = (threadId: string) => {
    setSelectedThreadId(threadId);
  };

  /**
   * Handle new thread creation
   */
  const handleNewThread = () => {
    setSelectedThreadId(null);
  };

  return (
    <AppLayout
      padding="none"
      active={
        location.pathname === "/appointments" ? "appointments" : "dashboard"
      }
    >
      <div className="flex flex-row h-full min-h-0">
          {location.pathname === "/appointments" ? (
            <div className="flex-1 p-4 overflow-auto min-h-0">
              <AppointmentsPage />
            </div>
          ) : (
            <>
              {/* THREADS SIDEBAR (ITS OWN COMPONENT ALREADY USES h-full/min-h-0) */}
              <ThreadsSidebar
                selectedThreadId={selectedThreadId}
                onThreadSelect={handleThreadSelect}
                onNewThread={handleNewThread}
              />

              {/* CHAT COLUMN: FLEX COL + min-h-0 SO INNER SCROLLER WORKS */}
              <div className="flex-1 flex flex-col overflow-hidden min-h-0">
                <div className="flex-1 p-4 overflow-hidden min-h-0">
                  <ChatBox
                    threadId={selectedThreadId}
                    onThreadCreated={setSelectedThreadId}
                  />
                </div>
              </div>
            </>
          )}
      </div>
    </AppLayout>
  );
};

export default Dashboard;
